'use client';
import { useState } from 'react';

function useControllableValue(e) {
    let t;
    let { value: r, onChange: l, defaultValue: i, defaultOnChange: n } = e, u = void 0 !== r, [a, d] = useState(i);
    return t = u ? void 0 !== l ? l : ()=>{} : (...o)=>{
        n(d, ...o), void 0 !== l && l(...o);
    }, [
        u ? r : a,
        t
    ];
}

export { useControllableValue };
